<div class="modal-content">
  <div class="modal-header" style="border-bottom: none !important;">
    <h5 style="padding: 0.5rem 1rem;" class="modal-title heading-6" id="modal-basic-title">
      {{ "common.policies.select-policy" | translate }}
    </h5>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
  </div>
  <div class="modal-body" style="padding-bottom: 0 !important;">
    <div class="form-group" style="padding: 0rem 1rem;">
      <select class="form-control icon-arrow-rtl" id="policySelect" [(ngModel)]="selectedPolicyUuid">
        <option *ngFor="let policy of policies" [value]="policy.uuid">
          {{ policy.name }}
        </option>
      </select>
    </div>
  </div>
  <div class="modal-footer custom-footer">
    <button style="color: white !important;" class="btn btn-primary" [disabled]="loading" (click)="confirm()">{{ "common.confirm" | translate }}</button>
  </div>
</div>